'use strict';

var _extends = require('../../../../node_modules/@babel/runtime/helpers/extends.js');
var objectWithoutProperties = require('../../../../node_modules/@babel/runtime/helpers/objectWithoutProperties.js');
var React = require('react');
var classNames = require('classnames');
require('prop-types');
var TextFormat = require('../../../../utils/TextFormat.js');
var TruncateText = require('../../../../utils/TruncateText.js');
var Typography = require('../../Typography/Typography.js');
var withStyles = require('../../../Styles/withStyles.js');
var ExpandableTableCell = require('../ExpandableTableCell.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var classNames__default = /*#__PURE__*/_interopDefaultLegacy(classNames);

var styles = {
  minimumHeight: {
    minHeight: ExpandableTableCell.TWO_ROW_HEIGHT
  }
};

var AddressTableCellContent = function AddressTableCellContent(_ref) {
  var classes = _ref.classes,
      _ref$wrapperComponent = _ref.wrapperComponent,
      Wrapper = _ref$wrapperComponent === void 0 ? 'div' : _ref$wrapperComponent,
      _ref$wrapperProps = _ref.wrapperProps,
      wrapperProps = _ref$wrapperProps === void 0 ? {} : _ref$wrapperProps,
      truncate = _ref.truncate,
      _ref$maxLines = _ref.maxLines,
      maxLines = _ref$maxLines === void 0 ? 1 : _ref$maxLines,
      dependencies = _ref.dependencies,
      children = _ref.children,
      props = objectWithoutProperties(_ref, ["classes", "wrapperComponent", "wrapperProps", "truncate", "maxLines", "dependencies", "children"]);

  var className = wrapperProps.className,
      otherWrapperProps = objectWithoutProperties(wrapperProps, ["className"]);

  return React__default["default"].createElement(Wrapper, _extends["default"]({
    className: classNames__default["default"](classes.minimumHeight, className)
  }, otherWrapperProps), React__default["default"].createElement(Typography, _extends["default"]({
    variant: "body1"
  }, props), React__default["default"].createElement(TruncateText, {
    truncate: truncate,
    maxLines: maxLines,
    dependencies: dependencies
  }, TextFormat.buildAddressLineOne(children))), React__default["default"].createElement(Typography, _extends["default"]({
    variant: "body1"
  }, props), React__default["default"].createElement(TruncateText, {
    truncate: truncate,
    maxLines: maxLines,
    dependencies: dependencies
  }, TextFormat.buildAddressLineTwo(children))));
};

var AddressTableCellContent$1 = withStyles["default"](styles)(AddressTableCellContent);

module.exports = AddressTableCellContent$1;
